import React from 'react'
import { Calculation } from './Calculation'
import { calculate, calculateBlended, RoasCellProps } from './RoasCellCalcs'

export const RoasCell = (props: RoasCellProps) => {
    const { color, sales, spend, roas } = calculate(props)

    const lines = [
        { description: 'Sales', value: sales },
        { description: '÷ Spend', value: spend },
        { description: 'ROAS', value: roas },
    ]

    return (
        <Calculation lines={lines}>
            <div className={color}>{roas}</div>
        </Calculation>
    )
}

export const BlendedRoasCell = (props: RoasCellProps) => {
    const { color, blendedProfit, spend, blendedRoas } = calculateBlended(props)

    const lines = [
        { description: 'Blended Profit', value: blendedProfit },
        { description: '÷ Spend', value: spend },
        { description: 'Blended ROAS', value: blendedRoas },
    ]

    return (
        <Calculation lines={lines}>
            <div className={color}>{blendedRoas}</div>
        </Calculation>
    )
}
